import { useEffect } from 'react'
import { FilterByColumnSettings, FilterNumber } from '../types'
import NumberFilterTypeSelect from './NumberFilterTypeSelect'
import { useNumberFilter } from './Number/numbers'
import { useAppDispatch } from 'app/state'
import { setColumnStatsStatus } from 'features/analysis/state/analysisSlice'
import { RequestStatus } from 'features/common'

function NumberFilterWrapper({
  type,
  disabled,
  onNumberFilterTypeChange,
  onChange
}: {
  type: FilterNumber
  disabled?: boolean
  onChange: (filterSettings?: FilterByColumnSettings) => void
  onNumberFilterTypeChange: (value: FilterNumber) => void
}) {
  const dispatch = useAppDispatch()
  const { component, filterSettings } = useNumberFilter(type)

  useEffect(() => {
    onChange(filterSettings)
  }, [onChange, filterSettings])

  useEffect(() => {
    return () => {
      dispatch(setColumnStatsStatus(RequestStatus.Idle))
    }
  }, [dispatch])

  return (
    <>
      <NumberFilterTypeSelect disabled={disabled} type={type} onChange={(value) => onNumberFilterTypeChange(value)} />
      {component}
    </>
  )
}

export default NumberFilterWrapper
